import React, { Suspense } from 'react';
import { LazyLoadingSpinner } from './LazyLoadingSpinner';
import { MainLoading } from '../Loading/MainLoading';

interface LazyRouteWrapperProps {
  children: React.ReactNode;
  fallbackMessage?: string;
}

export const LazyRouteWrapper: React.FC<LazyRouteWrapperProps> = ({ 
  children, 
  fallbackMessage 
}) => {
  return (
    <Suspense fallback={<LazyLoadingSpinner message={fallbackMessage} />}>
      {children}
    </Suspense>
  );
};

// Helper for route-level code splitting with consistent fallback
export const withLazyRoute = <T extends Record<string, any>>(
  LazyComponent: React.LazyExoticComponent<React.ComponentType<T>>,
  fallbackMessage?: string
) => {
  return React.forwardRef<React.ComponentRef<React.ComponentType<T>>, React.PropsWithoutRef<T>>((props, ref) => (
    <LazyRouteWrapper fallbackMessage={fallbackMessage}>
      <LazyComponent {...props} ref={ref} />
    </LazyRouteWrapper>
  ));
};

// Helper specifically for routes with MainLoading fallback
export const withLazyRouteMain = <T extends Record<string, any>>(
  LazyComponent: React.LazyExoticComponent<React.ComponentType<T>>
) => {
  return React.forwardRef<React.ComponentRef<React.ComponentType<T>>, React.PropsWithoutRef<T>>((props, ref) => (
    <Suspense fallback={<MainLoading />}>
      <LazyComponent {...props} ref={ref} />
    </Suspense>
  ));
}; 